// API mock configuration
// Controls whether API calls return mock data in non-production environments

import { isNonProductionEnv } from './enrollment-config';

const MOCK_MODE_KEY = 'dev_api_mock_enabled';

/**
 * Returns true if API mock mode is enabled.
 * Only available in non-production environments.
 */
export function isApiMockEnabled(): boolean {
  if (!isNonProductionEnv()) return false;
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(MOCK_MODE_KEY) === 'true';
}

/**
 * Sets the API mock mode (non-production only).
 */
export function setApiMockEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  if (enabled) {
    localStorage.setItem(MOCK_MODE_KEY, 'true');
  } else {
    localStorage.removeItem(MOCK_MODE_KEY);
  }
}
